export const enum ComparisonType {
    Equal = 0,
    NotEqual = 1,
    GreaterThan = 2,
    GreaterThanOrEqual = 3,
    LessThan = 4,
    LessThanOrEqual = 5,
    Contain = 6,
    StartWith = 7,
    EndWith = 8,
}

// From ClearView Data Models/Mongo/MongoEnums.cs
export const enum FieldTypes {
    String = 0,
    Int = 1,
    Double = 2,
    DateTime = 3,
    Boolean = 4,
    Null = 5,
    Time = 6,
}

export const enum HierarchyType {
    Employee = 0,
    PointOfContact = 1,
}

// Metrics.Enums.TimeType
export const enum TimeFormat {
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4,
}

export enum CurrencyFormat{
    USD = "Dollar",
    EUR = "Euro",
    CAD = "Canadian Dollar",
    GBP = "Sterling",
    JPY = "Japanese Yen",
    MXN = "Mexican Peso",
    AUD = "Australian Dollar",
    BRL = "Brazilian Real",
    PHP = "Philippine Peso",
    ARS = "Argentine Peso",
    COP = "Colombian Peso",
    ILS = "Israeli New Shekel",
    SEK = "Swedish Krona",
    CHF = "Swiss Franc"
}

export enum AggregationType { Sum = 0, Min = 1, Max = 2 }

export enum MetricTypes { Standard, RealTime, Calculated, RealTimeApi }
